import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  color: #fff;
  background: #000016;
  text-align: center;
  padding: 40px;
  @media (max-width: 1049px) {
    width: 100%;
  }
`;
export const Title = styled.div`
  padding: 10px;
  font-size: ${({ title }) => (title ? "20px" : "16px")};
  font-weight: ${({ title }) => title && "600"};
`;
